import { BookOpen, PenLine, Calculator, FlaskConical, Code2 } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { SUBJECTS } from "@/data/content";

const ICONS = { hindi: BookOpen, english: PenLine, maths: Calculator, science: FlaskConical, coding: Code2 };

const Subjects = () => (
    <section id="subjects" className="py-24 lg:py-32" data-testid="subjects-section">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
            <SectionHeading
                eyebrow="Subjects & Levels"
                title="Five subjects. Every stage. One standard — excellent."
                copy="Browse by subject and level, from early-years phonics to high-school mastery. Every class is live, small and personal."
            />
            <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-testid="subjects-grid">
                {SUBJECTS.map((s, i) => {
                    const Icon = ICONS[s.id];
                    if (s.large) {
                        return (
                            <Reveal key={s.id} delay={i * 0.08} className="md:row-span-2">
                                <Link
                                    to="/free-trial"
                                    data-testid={`subject-card-${s.id}`}
                                    className="group relative flex h-full min-h-[420px] flex-col justify-between overflow-hidden rounded-3xl border border-border card-shadow transition-all duration-300 hover:-translate-y-1.5 hover:lift-shadow"
                                >
                                    <img
                                        src={s.image}
                                        alt={`${s.name} classes at Hindi Ganga Online Classes`}
                                        className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-teal-dark via-teal-dark/45 to-teal-dark/10" />
                                    <div className="relative z-10 flex h-full flex-col justify-between p-8 lg:p-10">
                                        <span className="grid h-12 w-12 place-items-center rounded-2xl bg-cream/15 text-cream backdrop-blur-sm">
                                            <Icon className="h-6 w-6" />
                                        </span>
                                        <div>
                                            <h3 className="font-serif text-xl font-semibold tracking-tight text-cream md:text-2xl">
                                                {s.name}
                                            </h3>
                                            <p className="mt-1 font-serif italic text-saffron">{s.tagline}</p>
                                            <p className="mt-4 max-w-xs text-sm leading-relaxed text-cream/85">
                                                {s.description}
                                            </p>
                                            <div className="mt-8 flex items-center justify-between">
                                                <span className="text-xs font-medium uppercase tracking-[0.18em] text-cream/70">
                                                    {s.grades}
                                                </span>
                                                <span className="text-sm font-medium text-saffron transition-transform duration-300 group-hover:translate-x-1">
                                                    Try free →
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </Reveal>
                        );
                    }
                    return (
                        <Reveal key={s.id} delay={i * 0.08}>
                            <Link
                                to="/free-trial"
                                data-testid={`subject-card-${s.id}`}
                                className="group flex h-full flex-col overflow-hidden rounded-3xl border border-border bg-cream card-shadow transition-all duration-300 hover:-translate-y-1.5 hover:lift-shadow"
                            >
                                <div className="relative overflow-hidden">
                                    <img
                                        src={s.image}
                                        alt={`${s.name} classes at Hindi Ganga Online Classes`}
                                        className="aspect-[16/10] w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-teal-dark via-teal-dark/40 to-transparent" />
                                    <div className="absolute inset-x-0 bottom-0 flex items-end justify-between px-6 pb-4 pt-16">
                                        <div>
                                            <h3 className="font-serif text-xl font-semibold tracking-tight text-cream md:text-2xl">{s.name}</h3>
                                            <p className="mt-0.5 font-serif text-sm italic text-saffron">{s.tagline}</p>
                                        </div>
                                        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-cream/15 text-cream backdrop-blur-sm">
                                            <Icon className="h-5 w-5" />
                                        </span>
                                    </div>
                                </div>
                                <div className="flex flex-1 flex-col p-7">
                                    <p className="flex-1 text-sm leading-relaxed text-muted-foreground">{s.description}</p>
                                    <div className="mt-6 flex items-center justify-between border-t border-border pt-5">
                                        <span className="text-xs font-medium uppercase tracking-[0.18em] text-teal">{s.grades}</span>
                                        <span className="text-sm font-medium text-saffron-dark transition-transform duration-300 group-hover:translate-x-1">
                                            Try free →
                                        </span>
                                    </div>
                                </div>
                            </Link>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
);
export default Subjects;
